import React, { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { SensorDataDeviceSensorOption } from '../models';
import { useTranslation } from 'react-i18next';

interface QuickSensorSelectorProps {
  options: SensorDataDeviceSensorOption[];
  onSelect: (sensorIndex: number) => void;
}

export const QuickSensorSelector: FC<QuickSensorSelectorProps> = ({
  options,
  onSelect,
}: QuickSensorSelectorProps) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100%', p: 4 }}>
      <Typography variant="h6" color="textSecondary">
        {t('sensors_data_quick_select_sensor')}
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={2} justifyContent="center">
        {options.map((option: SensorDataDeviceSensorOption) => (
          <Button
            key={option.sensorIndex}
            variant="outlined"
            size="large"
            onClick={(): void => onSelect(option.sensorIndex)}
          >
            {option.sensorName}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
};
